import { createElement } from "react";
import { STEP_FRAME_CLASS } from "@/features/stepper/steptypes/step-shell";
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/shared/lib/api-client";
import { API_ENDPOINTS } from "@/shared/constants/api-endpoints";
import WebSmKeyHandoff from "@/features/stepper/steptypes/WebSmKeyHandoff_type";

export const Route = createFileRoute("/key-handoff_/code/$code")({
  component: KeyHandoffCode,
});

/**
 * Key-handoff display page for a specific KEY — `/key-handoff/code/<code>`.
 * This is the link sent in the text. The scan URL is never in this page's URL:
 * we derive the QR's data from the path `code` (`{origin}/code/<code>`) and
 * render a real scannable QR. Scanning it lands on `/code/<code>` (the
 * start-step landing that greets by the referrer's name).
 */
function KeyHandoffCode() {
  const { code } = Route.useParams();
  const qrData = `${window.location.origin}/code/${code}`;
  // the key's owner, engraved on its shaft (best-effort: without it the key
  // shows no name — never the viewer's own; see NameIsOwner)
  const { data: owner } = useQuery({
    queryKey: ["key-owner", code],
    staleTime: Infinity,
    retry: false,
    queryFn: async () => {
      const { data } = await apiClient.get(API_ENDPOINTS.qr.referrer(code));
      return (data?.result?.referrerName as string | undefined) ?? "";
    },
  });
  const opts: Record<string, string> = {
    QrData: qrData,
    Name: owner ?? "",
    NameIsOwner: "1",
  };
  const getOpt = (name: string): string => opts[name] ?? "";
  // in the same phone-shaped frame as every other step
  return (
    <div className={STEP_FRAME_CLASS}>
      {createElement(WebSmKeyHandoff, { getOpt, dispatch: () => {} })}
    </div>
  );
}
